'use client';

import { useMemo } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { PRODUCT_QUERY_PARAMS } from '@/features/navigation/constants';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import Pagination from '@/features/pagination/pagination';
import { PaginationArrowSize } from '@/features/pagination/type';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import usePLPData from '../_utils/use-plp-data';
import { FIRST_LOAD_PAGE_SIZE, PAGE_SIZE } from '../constants';
import { usePLPFacetsContext } from '../facets-context/facets-context';
interface Props {
  pageCount: number;
  onPageChange: (page: number) => void;
}
function PLPPagination({
  pageCount,
  onPageChange
}: Props) {
  const {
    searchParams
  } = usePLPFacetsContext();
  const {
    searchParamsPageNumber
  } = usePLPData({
    searchParams
  });
  const {
    isMobile
  } = useMobileDetect();
  const windowSearchParams = useSearchParams();
  const pathName = usePathname();
  const initialPage = useMemo(() => {
    if (typeof searchParamsPageNumber === 'number') {
      return searchParamsPageNumber;
    } else if (PUBLIC_IS_BOT) {
      return 1;
    } else {
      return Math.min(pageCount, FIRST_LOAD_PAGE_SIZE / PAGE_SIZE);
    }
  }, [searchParamsPageNumber, pageCount]);
  if (pageCount <= 1) return null;
  const hrefBuilder = (page: number) => {
    if (windowSearchParams) {
      const query = new URLSearchParams(windowSearchParams.toString());
      query.set(PRODUCT_QUERY_PARAMS.PAGE_NUMBER, page.toString());
      if (page === 1) {
        query.delete(PRODUCT_QUERY_PARAMS.PAGE_NUMBER);
      }
      return query.toString() ? `?${query.toString()}` : pathName;
    } else {
      return page === 1 ? '/' : `?${PRODUCT_QUERY_PARAMS.PAGE_NUMBER}=${page}`;
    }
  };
  return <Pagination onPageChange={onPageChange} page={initialPage} pageCount={pageCount} size={isMobile ? PaginationArrowSize.Medium : PaginationArrowSize.Large} className='mt-4 lg:mt-6' hrefBuilder={hrefBuilder} data-sentry-element="Pagination" data-sentry-component="PLPPagination" data-sentry-source-file="plp-pagination.tsx" />;
}
export default PLPPagination;